<template>
    <div class="header-stats" v-if="!authenticatedUser.permissions.includes('franchise-sales-man')">
        <!-- Always visible - from localStorage -->
    <span>
      Welcome {{ authenticatedUser.first_name }} {{ authenticatedUser.last_name }},
      {{ authenticatedUser?.branch?.name }} Branch
    </span>

        <!-- Loading skeleton for dynamic data -->
        <template v-if="loading">
            <span class="ml-3 skeleton skeleton-text skeleton-rank"></span>
            <span class="ml-3 skeleton skeleton-text skeleton-seller"></span>
            <span class="ml-3">
                <div class="card border-0" style="border-radius: 12px; background: rgba(255,255,255,0.08); border: 1px solid rgba(255,255,255,0.1) !important; width: 100%;">
                    <div class="card-body p-1">
                        <div class="d-flex align-items-center">
                            <div class="skeleton skeleton-circle"></div>
                            <div class="ms-2">
                                <div class="skeleton skeleton-text skeleton-branch-name"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </span>
        </template>

        <!-- Real data when loaded -->
        <template v-else>
            <span v-if="branch_ranking&&branch_ranking[0].total_collection>0" class="ml-3">
                | 📊 Branch Rank: <strong>#{{ currentBranchRank }}</strong>
            </span>
            <span v-if="topSeller && topSeller.today_sales>0" class="ml-3 seller-name-span">
                | 🏆  <strong class="seller-name">{{ topSeller.fullName }} £{{ topSeller.today_sales }}</strong>
            </span>
            <span v-if="branch_ranking&&branch_ranking[0].total_collection>0" class="ml-3">
                <div class="card border-0 " style="border-radius: 12px; background: rgba(255,255,255,0.08); border: 1px solid rgba(255,255,255,0.1) !important; width: 100%;">
                    <div class="card-body p-1">
                        <div class="d-flex align-items-center">
                            <div class="flex-shrink-0 d-flex align-items-center justify-content-center rounded-circle"
                                 style="width: 40px; height: 40px; background-color: #ecfdf5; color: #10b981;">
                                <i class="bi bi-graph-up-arrow fs-6"></i>
                            </div>
                            <div class="ms-2 overflow-hidden">
                                <span class="text-light fw-bold mb-0 text-truncate" style="font-size: 17px; line-height: 1.2; margin-left: 2px">
                                    {{branch_ranking[0].branch_name}}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </span>
        </template>
    </div>
</template>

<script>
import apiService from "@/service/apiService";

export default {
    name: "welcomenote",
    // Data must return an object to be reactive in Vue
    data() {
        return {
            topSeller: null,
            branch_ranking: [],
            polling: null,
            loading: true,
        };
    },
    computed: {
        authenticatedUser() {
            // LocalStorage is better handled in a try-catch or via Vuex,
            // but keeping your logic:
            let user = localStorage.getItem('user');
            return user ? JSON.parse(user) : null;
        },

        // Logic to find the rank of the authenticated user's branch
        currentBranchRank() {
            if (!this.branch_ranking.length || !this.authenticatedUser) return null;

            const userBranchId = this.authenticatedUser.branch.id;
            const branchData = this.branch_ranking.find(b => b.branch_id === userBranchId);

            return branchData ? branchData.this_month_rank : 'N/A';
        }
    },
    async mounted() {
        await this.fetchData();

        // Set up the 5-minute interval
        this.polling = setInterval(async () => {
            await this.fetchData();
        }, 300000);
    },
    beforeUnmount() {
        if (this.polling) {
            clearInterval(this.polling);
        }
    },
    methods: {
        async fetchData() {
            await Promise.all([
                this.getTopSellerOfDay(),
                this.branchRanking()
            ]);
            this.loading = false;
        },
        async getTopSellerOfDay() {
            try {
                const { data } = await apiService.get(`/top-seller-of-day`);
                this.topSeller = data;
            } catch (error) {
                console.error("Error fetching top seller:", error);
            }
        },
        async branchRanking() {
            try {
                const { data } = await apiService.get(`/branch-ranking`);
                this.branch_ranking = data;
            } catch (error) {
                console.error("Error fetching branch ranking:", error);
            }
        },
    }
}
</script>

<style scoped>
.ml-3 { margin-left: 1rem; }

/* Seller name truncation */
.seller-name-span {

    display: inline-block;
    vertical-align: middle;
}

.seller-name {
    display: inline-block;

    vertical-align: middle;
}

.header-stats {
    display: flex;
    align-items: center;
    margin-top: -9px;
}

/* Skeleton Loading Styles - bright shimmer */
.skeleton {
    background: linear-gradient(90deg, rgba(255,255,255,0.15) 25%, rgba(255,255,255,0.4) 50%, rgba(255,255,255,0.15) 75%);
    background-size: 200% 100%;
    animation: shimmer 1.5s infinite;
    border-radius: 4px;
}

@keyframes shimmer {
    0% { background-position: -200% 0; }
    100% { background-position: 200% 0; }
}

.skeleton-text {
    display: inline-block;
    height: 16px;
    vertical-align: middle;
}

.skeleton-rank {
    width: 130px;
}

.skeleton-seller {
    width: 150px;
}

.skeleton-circle {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    flex-shrink: 0;
}

.skeleton-branch-name {
    width: 100px;
    height: 16px;
}
</style>
